<template>
  <div class="showcase-home-hero-register showcase-home-hero-wxlogin">
    <WeixinLoginHeader :iconSize="40" iconColor="#fff" />
    <component :is="currentLoginStep.component" />
    <div class="footer">
      <div class="action">
        <button class="button basic" @click="onClickBackButton">
          {{ backActionText }}
        </button>
        <button class="button basic" @click="onClickLoginButton">
          {{ loginActionText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import WeixinLoginHeader from '@/weixin/login/components/weixin-login-header';
import WeixinLoginIframe from '@/weixin/login/components/weixin-login-iframe';
import WeixinLoginConnect from '@/weixin/login/components/weixin-login-connect';
import WeixinLoginAccount from '@/weixin/login/components/weixin-login-account';
import { socket } from '@/app/app.service';

export default defineComponent({
  name: 'ShowcaseHomeHeroWxLogin',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentStepName: 'invite/currentStepName',
      currentStep: 'invite/currentStep',
      currentLoginStep: 'weixin/login/currentLoginStep',
      isLoggedIn: 'auth/isLoggedIn',
      name: 'invite/register/name',
      password: 'invite/register/password',
    }),

    actionButtonText() {
      return '立即登录';
    },

    backActionText() {
      return this.isLoggedIn ? '← 访问首页' : '← 回到前台';
    },

    loginActionText() {
      return '直接登录 →';
    },
  },

  /**
   * 已创建
   */
  created() {
    this.resetLoginStep();

    socket.on('weixinLoginConnect', this.onWeixinLoginConnect);
    socket.on('weixinLoginSucceeded', this.onWeixinLoginSucceeded);
  },

  /**
   * 取消挂载
   */
  unmounted() {
    socket.off('weixinLoginConnect', this.onWeixinLoginConnect);
    socket.off('weixinLoginSucceeded', this.onWeixinLoginSucceeded);
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      resetLoginStep: 'weixin/login/resetLoginStep',
      setCurrentLoginStepName: 'weixin/login/setCurrentLoginStepName',
      setWeixinUserInfo: 'weixin/login/setWeixinUserInfo',
      setCurrentStepName: 'invite/setCurrentStepName',
    }),

    ...mapActions({
      weixinLogin: 'weixin/login/weixinLogin',
    }),

    onWeixinLoginConnect(weixinUserInfo) {
      this.setWeixinUserInfo(weixinUserInfo);
      if (this.name && this.password) {
        this.setCurrentLoginStepName('verifyAccount');
      } else {
        this.setCurrentLoginStepName('connectAccount');
      }
    },

    async onWeixinLoginSucceeded(data) {
      await this.weixinLogin(data);

      if (this.canGoBack) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },

    async onClickActionButton() {
      if (!this.name) {
        return (this.statusText = '请输入用户名。');
      }

      if (!this.password) {
        return (this.statusText = '请输入用户密码。');
      }

      try {
        await this.login({
          name: this.name,
          password: this.password,
          device: { type: 'web' },
        });

        this.$router.push('/');
      } catch (error) {
        if (error.data && Array.isArray(error.data.message)) {
          this.statusText = error.data.message[0];
        }

        if (
          error.data &&
          !Array.isArray(error.data.message) &&
          error.data.message
        ) {
          this.statusText = error.data.message;
        }
      }
    },

    onClickLoginButton() {
      this.setCurrentStepName('login');
    },

    onClickBackButton() {
      if (this.isLoggedIn) {
        return this.$router.push('/');
      }

      this.setCurrentStepName('initial');
    },
  },

  /**
   * 使用组件
   */
  components: {
    WeixinLoginAccount,
    WeixinLoginConnect,
    WeixinLoginIframe,
    WeixinLoginHeader,
  },
});
</script>
<style scoped>
@import './styles/showcase-home-hero-wxlogin.css';
</style>
